import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/Icon.png'


const _withScopeId = n => (_pushScopeId("data-v-6212eb18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-topbar p-d-flex p-jc-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    src: _imports_0,
    height: "40",
    class: "p-mr-2"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Menubar, { model: $setup.homeMenu }, {
      start: _withCtx(() => [
        _hoisted_2
      ]),
      end: _withCtx(() => [
        (!$props.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'login' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  label: "Đăng nhập",
                  icon: "pi pi-sign-in",
                  iconPos: "right"
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              label: "Đăng xuất",
              onClick: $setup.logout,
              icon: "pi pi-sign-out",
              iconPos: "right",
              class: "p-button-secondary"
            }, null, 8, ["onClick"]))
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}